import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  companies: [],
  selectedFilters: {
    sort: "-createdAt",
  },
};

const companySlice = createSlice({
  name: "companyFeature",
  initialState,
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    updateSelectedFilters: (state, action) => {
      // Replace the entire selectedFilters object to allow removal of properties
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      // When the store is rehydrated, ensure we maintain our sort value
      if (action.payload && action.payload.companyFeature) {
        const persistedData = action.payload.companyFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const {
  setCompanies,
  updateSelectedFilters,
  resetSelectedFilters,
} = companySlice.actions;

export default companySlice.reducer;
